import { decorate, observable, action, computed } from 'mobx';
import * as Api from '../lib/api';
import { loc } from '../lib/loc';
import { ErrorLoc } from '../loc/error';
import { cartStorageKey } from './CartStore';
import { stores } from '../contexts/index';

export const FIRST_AUTH_MESSAGE_SHOWED = '_arlift_first_auth_message_showed';

export class LoginStore {
    loader = false;
    errorMessage = null;
    success = false;
    logoutSuccess = false;

    setErrorMessage = message => {
        this.errorMessage = message;
    };

    login = (phone, password) => {
        this.loader = true;
        this.errorMessage = null;

        const data = {
            login: phone.match(new RegExp(/[0-9]/g)).join(''),
            password,
        };

        Api.fetch('auth/login', data, 'POST')
            .then(response => {
                if (response.success) {
                    Api.setUserID(response.result.user_id);
                    Api.setToken(`${response.result.login} ${response.result.token}`);
                    this.success = true;
                }
            })
            .catch(response => {
                this.errorMessage = response.error_description || loc(ErrorLoc.unknownError);
            })
            .finally(() => {
                this.loader = false;
            });
    };

    logout = history => {
        this.success = false;
        Api.fetch('auth/logout', {}, 'POST')
            .then()
            .finally(() => {
                Api.deleteToken();
                Api.setUserID(0);
                localStorage.removeItem(cartStorageKey);
                this.setFirstAuthMessageShowed(false);
                stores.ProfileDataStore.resetStore();
                history.push('/');
            });
    };

    get firstAuthMessageShowed() {
        return !!localStorage.getItem(FIRST_AUTH_MESSAGE_SHOWED);
    }

    setFirstAuthMessageShowed = state => {
        if (state) {
            localStorage.setItem(FIRST_AUTH_MESSAGE_SHOWED, state);
        } else {
            localStorage.removeItem(FIRST_AUTH_MESSAGE_SHOWED);
        }
    };
}

decorate(LoginStore, {
    loader: observable,
    errorMessage: observable,
    success: observable,
    logoutSuccess: observable,

    login: action,
    logout: action,
    setErrorMessage: action,

    firstAuthMessageShowed: computed,
    setFirstAuthMessageShowed: action,
});
